import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import { selectSelectedTenantId } from '../store/multi-site-dashboard.selectors';

export const multiSiteDashboardPageLifecycleManager = (
  dataLoadFn: () => void,
  dataClearFn: (tenantIdChange?: boolean) => void
): {
  init: () => void;
  clearData: () => void;
} => {
  const store = inject(Store);
  const destroyRef = inject(DestroyRef);
  const selectedTenantId$ = store.select(selectSelectedTenantId);

  return {
    init: () => {
      let firstEmit = true;
      selectedTenantId$.pipe(takeUntilDestroyed(destroyRef)).subscribe((tenantId) => {
        if (tenantId) {
          dataClearFn(!firstEmit);
          dataLoadFn();
          firstEmit = false;
        }
      });
    },
    clearData: dataClearFn,
  };
};
